import { z } from "zod";
import { LAB_STATES } from "./catalogue/lab-states.ts";

/**
 * The labs views (openspec change `model-picking`, D1, D10, D17, slice 4c): one row per lab,
 * with its state, its recorded evaluation (the "Tested by ESI" badge) and where it is available.
 * Display names only: never an account ID.
 */

const evaluationSchema = z.object({ date: z.string(), catalogueVersion: z.string() });

/** One lab of the stage, as operators see it (console Model connections, Labs). */
export const operatorLabViewSchema = z.object({
  lab: z.string(),
  displayName: z.string(),
  state: z.enum(LAB_STATES),
  evaluation: evaluationSchema.nullable(),
  /** The served geographies the lab has a version in (`eu`, `global`). */
  geographies: z.array(z.string()),
  /** Every tenant's default lab (`INSTANCE_DEFAULT_LABS`): never blockable. */
  defaultLab: z.boolean(),
  /** Tenants that opted in (a row of their own naming it); null: unknown. */
  tenants: z.number().int().min(0).nullable(),
  /** A probe of one of its versions was denied: Bedrock model access may need enabling. */
  accessDenied: z.boolean(),
});
export type OperatorLabView = z.infer<typeof operatorLabViewSchema>;

/** `GET /operator/model-labs`. */
export const operatorModelLabsSchema = z.object({ labs: z.array(operatorLabViewSchema) });
export type OperatorModelLabs = z.infer<typeof operatorModelLabsSchema>;

/** One lab a tenant admin may offer (a blocked lab is never listed), in `GET …/model-health`. */
export const scopeLabViewSchema = z.object({
  lab: z.string(),
  displayName: z.string(),
  state: z.enum(["untested", "tested"]),
  evaluation: evaluationSchema.nullable(),
  /** In the scope's `models.labs`. */
  offered: z.boolean(),
  geographies: z.array(z.string()),
  /**
   * It has a version in one of the scope's geographies; false: "not available in the EU" for an
   * EU-only scope (it may be offered, it resolves nothing there).
   */
  availableHere: z.boolean(),
});
export type ScopeLabView = z.infer<typeof scopeLabViewSchema>;
